import styled from "styled-components";
import { colors } from "./colors/color";

type LinkVariants = 'default' | 'dark';

type LinkColorSettings = {
    normal: string;
    hover: string;
}


export const Link = styled.a<{colorSettings?: LinkColorSettings}>`
    
    text-decoration: none;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;

    color:${props => props.colorSettings?.normal || colors.link.default.normal};
    
    svg {
        fill:${props => props.colorSettings?.normal || colors.link.default.normal};
    }
    &:hover, :hover svg{
        color:${props => props.colorSettings?.hover || colors.link.default.hover};
    }
    &:hover svg {
        fill:${props => props.colorSettings?.hover || colors.link.default.hover};
    }
`;

export const DarkLink = styled.a<{variant?:LinkVariants}>`
    
    text-decoration: none;
    
    color:${props => props.theme.colors.link.dark.normal};

    svg {
        fill:${props => props.theme.colors.link.dark.normal};
    }

    &:hover {
        color:${props => props.theme.colors.link.dark.hover};
    }
    &:hover svg {
        fill:${props => props.theme.colors.link.dark.hover};
    }
`;